/* Structure de la pratique STEPS --> Restructuré pour le formulaire */
/* Claude à aidée à réflchir */

export default class Formulaire{
    constructor(element){
        this.element = element;

        this.slideActive = 1;
        this.slidesNumbers = this.element.querySelectorAll('.form__step');
        this.buttons = this.element.querySelectorAll('.btn');

        this.init();
    }

    init(){
        for (let i = 0; i < this.buttons.length; i++) {
            const button = this.buttons[i];
            button.addEventListener('click', this.changeSlide.bind(this));
        }

        // Écoute les changements sur les inputs en temps réel
        const allInputs = this.element.querySelectorAll('.input__element');
        for (let i = 0; i < allInputs.length; i++) {
            allInputs[i].addEventListener('input', this.checkInputs.bind(this));
        }
    }


    /* Code Claude */
    checkInputs() {
        const currentSlide = this.element.querySelector(`.js-slide${this.slideActive}`);
        const inputs = currentSlide.querySelectorAll('.input__element');
        const suivant = currentSlide.querySelector('.js-suivant');

        if (!suivant) return;

        for (let i = 0; i < inputs.length; i++) {
            if (inputs[i].value == '') {
                suivant.classList.remove('is-active');
                return;
            }
        }

        suivant.classList.add('is-active');
    }
    /* ---------- */

    changeSlide(event) {
        const button = event.currentTarget;

        if (button.classList.contains('js-precedent')) {
            if (this.slideActive > 1) {
                this.slideActive -= 1;
            }
        }

        if (button.classList.contains('js-suivant')) {
            /* Empèche de cliquer sur suivant SI champs pas remplis */
            if (!button.classList.contains('is-active')) {
                return;
            }

            if (this.slideActive < this.slidesNumbers.length) {
                this.slideActive += 1;
            }
        }

        for (let i = 0; i < this.slidesNumbers.length; i++) {
            this.slidesNumbers[i].classList.remove('is-active');
        }

        this.element.querySelector(`.js-slide${this.slideActive}`).classList.add('is-active');

        /* Change les class des 3 étapes */
        const nbrEtape = 3;
        for (let i = 1; i <= nbrEtape; i++) {
            document.querySelector(`.js-etape${i}`).classList.remove('btn--black');
            document.querySelector(`.js-etape${i}`).classList.add('btn--outline');
        }

        document.querySelector(`.js-etape${this.slideActive}`).classList.remove('btn--outline');
        document.querySelector(`.js-etape${this.slideActive}`).classList.add('btn--black');
    }
}